module.exports = __webpack_public_path__ + "img/SCUML.79fd12ec.png";